<lfw-offline-order-list [orders$]="temporaryOfflineOrders$" [showTemporaryOrderList]="true" />
